import AvaliableMeals from "./AvaliableMeals";
import MealsSummary from "./MealsSummary";

export default function Meals() {
  return (
    <>
      <MealsSummary />
      <AvaliableMeals />
    </>
  );
}
